import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types'

export default {
  title: {
    id: 'product_jp_black_friday_special_title',
    defaultMessage: 'Only Black Friday!',
  },
  about: {
    id: 'product_jp_product_black_friday_special_paragraph',
    defaultMessage: 'Items that are ¥20,000 or more',
  },
  tag: {
    id: 'product_jp_black_friday_special_tag',
    defaultMessage: '10%OFF',
  },
} as Record<string, I18nDefinition>
